/* Reveal animations */
var rvObs = new IntersectionObserver(function(es) {
  es.forEach(function(e) {
    if (e.isIntersecting) { e.target.classList.add('on'); rvObs.unobserve(e.target); }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
document.querySelectorAll('.rv').forEach(function(el) { rvObs.observe(el); });

/* Filter articles by tag */
function filterArticles(cat, btn) {
  document.querySelectorAll('.filter-btn').forEach(function(b) { b.classList.remove('on'); });
  btn.classList.add('on');
  var cards = document.querySelectorAll('.article-card');
  var visible = 0;
  cards.forEach(function(card) {
    if (cat === 'all') {
      card.classList.remove('hidden');
      visible++;
    } else {
      var cats = (card.dataset.cats || '').split(' ');
      if (cats.indexOf(cat) > -1) {
        card.classList.remove('hidden');
        visible++;
      } else {
        card.classList.add('hidden');
      }
    }
  });
  var noResults = document.getElementById('no-results');
  if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
}
